import Vue from "vue";
import { Component } from "vue-property-decorator";
import { ParametreDto } from "../../../dto/GenApi.iNotPaie.Dto/ParametreDto";
import moment from "moment";
import { EventBus } from "../../Controls/EventBus";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { ParametresInstance } from "../../Controls/Parameters";
import EventConstants from "../../Controls/EventConstants";
import { mask } from "vue-the-mask";
import { SalarieLightDto } from "../../../dto/GenApi.iNotPaie.Dto/SalarieLightDto";
import { UtilisateurExterneDto } from "../../../dto/GenApi.iNotPaie.Dto/UtilisateurExterneDto";
import { SalarieDto } from "../../../dto/GenApi.iNotPaie.Dto/SalarieDto";
import { UtilisateurLightDto } from "../../../dto/GenApi.iNotPaie.Dto/UtilisateurLightDto";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const image_mr = require("../../../assets/img_avatar_MR.png");
// eslint-disable-next-line @typescript-eslint/no-var-requires
const image_mme = require("../../../assets/img_avatar_MME.png");

interface salarieChargeInfos {
	srcImage?: string;
	isModified: boolean;
	dateNaissance: string;
	dateEntree: string;
	dateSortie: string;
	// eslint-disable-next-line no-use-before-define
	salarieCourant?: salarieModel;
}

interface salarieModel {
	salarie: SalarieLightDto,
	Photo: string
}

@Component({
	directives: { mask }
})
export default class IdentiteSalarieComponent extends Vue {
	public currentId = -1;
	public dataReady = false;
	public isModified = false;
	public srcImage?: string = "";
	public salarieCourant?: salarieModel = undefined;
	public salarieCharges: salarieChargeInfos[] = [];
	public listIdCharges: number[] = [];
	public listeCivilite: ParametreDto[] = [];
	public dateNaissance = "";
	public dateEntree = "";
	public dateSortie = "";
	public isInitialized = false;

	public maxBirthDate: string = new Date().toLocaleDateString();
	public numeroSecuriteSociale = "";

	public listeSalarie: SalarieDto[] = [];
	public listeTousSalarie: SalarieDto[] = [];
	public listeUtilisateursExternes: UtilisateurExterneDto[] = [];
	public utilisateurs: UtilisateurLightDto[] = [];

	public updateSecuritySocialNumber(): void {
		if (this.salarieCourant != undefined && this.salarieCourant.salarie != undefined) {
    		let numeroSecuriteSocialeAuto = this.numeroSecuriteSociale.replace(/ /gi, "");
    		// Civility (1 char)
    		let civilityCode = "";
    		if (this.salarieCourant.salarie.CodeCivilite === "M.") {
    			civilityCode = "1";
    		} else if (this.salarieCourant.salarie.CodeCivilite === "MLE" || this.salarieCourant.salarie.CodeCivilite === "MME") {
    			civilityCode = "2";
    		}
    		if (numeroSecuriteSocialeAuto != undefined && civilityCode != "") {
    			numeroSecuriteSocialeAuto = civilityCode + numeroSecuriteSocialeAuto.substr(0 + civilityCode.length);
    		}

    		// Year of birth (2 & 3 characters)
    		if (this.dateNaissance != undefined && this.dateNaissance != "") {
    			const yearOfBirth = this.dateNaissance.toString().split("-")[0].substr(-2);
    			if (numeroSecuriteSocialeAuto.length > 1) { // MAJ
    				numeroSecuriteSocialeAuto = numeroSecuriteSocialeAuto.substr(0, 1) + yearOfBirth + numeroSecuriteSocialeAuto.substr(1 + yearOfBirth.length);
    			} else { // 1ère fois
    				numeroSecuriteSocialeAuto += yearOfBirth;
    			}
    		}

    		// birth month (4 & 5 characters)
    		if (this.dateNaissance != undefined && this.dateNaissance != "") {
    			const monthOfBirth = this.dateNaissance.toString().split("-")[1].substr(-2);
    			if (numeroSecuriteSocialeAuto.length > 3) { // MAJ
    				numeroSecuriteSocialeAuto = numeroSecuriteSocialeAuto.substr(0, 3) + monthOfBirth + numeroSecuriteSocialeAuto.substr(3 + monthOfBirth.length);
    			} else { // 1ère fois
    				numeroSecuriteSocialeAuto += monthOfBirth;
    			}
    		}

    		this.setNumeroSecuriteSocial(numeroSecuriteSocialeAuto);
    	}
	}

	public isNumber(value: string | number): boolean {
    	return ((value != null) && !isNaN(Number(value.toString())));
	}

	public reloadData(id: number): void {
		if (id <= 0) {
    		this.resetData(0);
    	} else {
    		if (this.currentId >= 0) {
    			this.salarieCharges[this.currentId] = {
    				dateNaissance: this.dateNaissance,
    				dateSortie: this.dateSortie,
    				dateEntree: this.dateEntree,
    				salarieCourant: this.salarieCourant,
    				srcImage: this.srcImage,
    				isModified: this.isModified
    			};
    		}
    	}

    	this.currentId = id;
    	this.fetchData();
	}

	public init(): void {
    	if (this.isInitialized || ParametresInstance.utilisateurCourant == undefined) {
    		return;
    	}

    	this.initConstantes();
    	this.isInitialized = true;
	}

	public mounted(): void {
    	this.isInitialized = false;

    	this.maxBirthDate = moment.utc().format("YYYY-MM-DD");

    	// On ne sait pas dans quel ordre ça peut arriver (1er appel ou refresh de la page...)
    	EventBus.$on(EventConstants.UTILISATEUR_CHANGED, () => {
    		this.init();
    	});
    	EventBus.$on("closeTab", e => {
    		if (e.route == this.$route.path) {
    			this.isModified = false;
    		}
    	});
    	this.init();
	}

	public resetData(id: number): void {
    	if (this.salarieCharges[id] != undefined) {
    		this.salarieCharges[id].isModified = false;
    	}
    	if (this.currentId == id) {
    		this.fetchData();
    	}
	}

	public initConstantes(): void {
    	ServicesFactoryInstance.ParametresService.getCivilites(data => {
    		this.listeCivilite = data;
    	});
    	ServicesFactoryInstance.UtilisateurExterneService.getListe(data => {
    		this.listeUtilisateursExternes = data;
    	});
    	ServicesFactoryInstance.UtilisateursService.getUtilisateurs(data => {
    		this.utilisateurs = data;
    	});
	}

	public fetchData(): void {
    	this.dataReady = false;
    	if (ParametresInstance.societeCourante != undefined && this.listeSalarie.length == 0) {
    		ServicesFactoryInstance.SalarieService.getSalariesActifs(data => {
    			this.listeTousSalarie = data;
    			this.listeSalarie = this.listeTousSalarie.filter(d => d.Id != this.currentId).sort((a, b) => a.FullName != undefined && b.FullName != undefined && a.FullName > b.FullName ? 1 : -1);
    		});
    	}
    	this.listeSalarie = this.listeTousSalarie.filter(d => d.Id != this.currentId).sort((a, b) => a.FullName != undefined && b.FullName != undefined && a.FullName > b.FullName ? 1 : -1);
    	if (this.salarieCharges[this.currentId] == null || !this.salarieCharges[this.currentId].isModified) {
    		if (this.currentId != 0) {
    			ServicesFactoryInstance.SalarieService.getSalarieLight(this.currentId, data => {
    				this.setData(data);
    			});
    		} else {
				if (!this.isModified) {
    				this.salarieCourant = {
    					Photo: "",
    					salarie: { Id: 0 }
    				};

    				this.numeroSecuriteSociale = "";
    				this.isModified = true;
    				this.srcImage = image_mr;
    				this.$emit("isModified", true);
    				this.dateNaissance = "";
    				this.dateSortie = "";
    				this.dateEntree = "";
    			}
    			this.dataReady = true;
    		}
    	} else {
    		this.dataReady = true;
    		this.salarieCourant = this.salarieCharges[this.currentId].salarieCourant;
    		this.dateNaissance = this.salarieCharges[this.currentId].dateNaissance;
    		this.dateSortie = this.salarieCharges[this.currentId].dateSortie;
    		this.dateEntree = this.salarieCharges[this.currentId].dateEntree;
    		this.srcImage = this.salarieCharges[this.currentId].srcImage;
    		this.isModified = this.salarieCharges[this.currentId].isModified;
    		if (this.salarieCourant != undefined) {
    			if (this.salarieCourant.salarie.NumSecu != undefined) {
					this.setNumeroSecuriteSocial(this.salarieCourant.salarie.NumSecu);
				} else {
					this.numeroSecuriteSociale = "";
				}
    		}
    	}
	}

	public setNumeroSecuriteSocial(val: string): void {
    	this.numeroSecuriteSociale = "";
    	for (let i = 0; i < val.length; i++) {
    		this.numeroSecuriteSociale += val[i];
    		if ((i == 0 || i == 2 || i == 4 || i == 6 || i == 9 || i == 12) && i < val.length - 1) {
				this.numeroSecuriteSociale += " ";
			}
    	}
	}

	public modifiyNumeroSecuriteSocial(): void {
    	this.setNumeroSecuriteSocial(this.numeroSecuriteSociale.replace(/ /gi, ""));
    	this.modify();
	}

	public setData(data: SalarieLightDto): void {
		this.salarieCourant = { salarie: data, Photo: data.Photo != undefined ? data.Photo : "" };

    	if (this.salarieCourant == undefined) {
			return;
		}

    	if (this.salarieCourant.salarie.NumSecu != undefined) {
			this.setNumeroSecuriteSocial(this.salarieCourant.salarie.NumSecu);
		} else {
			this.numeroSecuriteSociale = "";
		}

    	if (this.salarieCourant.Photo != "") {
    		this.srcImage = this.salarieCourant.Photo;
    	} else if (this.salarieCourant.salarie.Civilite == "M.") {
    		this.srcImage = image_mr;
    	} else {
    		this.srcImage = image_mme;
    	}
    	this.dateNaissance = moment.utc(this.salarieCourant.salarie.DateNaissance).format("YYYY-MM-DD");
    	this.dateSortie = moment.utc(this.salarieCourant.salarie.DateSortie).format("YYYY-MM-DD");
    	this.dateEntree = moment.utc(this.salarieCourant.salarie.DateEntree).format("YYYY-MM-DD");

    	this.dataReady = true;
	}

	public enregistrer(): boolean {
    	const errorMessage: string[] = [];
    	// TODO régles de validations complèxes

    	if (this.salarieCourant == undefined) {
			return false;
		}
    	if (ParametresInstance.societeCourante == undefined) {
			return false;
		}
    	this.salarieCourant.salarie.NumSecu = this.numeroSecuriteSociale.replace(/ /gi, "");
    	// controlles sur le N° de sécu
    	if (this.salarieCourant.salarie.NumSecu == undefined) {
    		errorMessage.push("Le numéro de sécurité sociale est obligatoire");
    	} else {
    		const numeroSecu = this.salarieCourant.salarie.NumSecu.toUpperCase().replace(/ /gi, "").replace(/\t/gi, "").replace(/2A/gi, "19").replace(/2B/gi, "18");

    		if (isNaN(Number(numeroSecu))) {
    			errorMessage.push("Le numéro de sécurité sociale doit être un nombre");
    		} else if (numeroSecu.length != 15) {
    			errorMessage.push("Le numéro de sécurité sociale doit faire 15 caractères (13+2)");
    		} else {
    			const cle = Number(numeroSecu.substring(13));
    			const numero = Number(numeroSecu.substring(0, 13));
    			const calcule = 97 - numero % 97;
    			if (calcule != cle) {
    				errorMessage.push("Le numéro de sécurité sociale ne répond pas aux critères de validation par la clé");
    				console.warn("La bonne clé est : " + calcule);
    			}
    		}

    		if (this.salarieCourant.salarie.CodeCivilite === "M." && numeroSecu.charAt(0) != "1") {
    			errorMessage.push("Les personnes de sexe masculin doivent avoir un N° de sécurité sociale commençant par 1");
    		}
    		if ((this.salarieCourant.salarie.CodeCivilite === "MLE" || this.salarieCourant.salarie.CodeCivilite === "MME") && numeroSecu.charAt(0) != "2") {
    			errorMessage.push("Les personnes de sexe feminin doivent avoir un N° de sécurité sociale commençant par 2");
    		}
    		this.salarieCourant.salarie.NumSecu = this.salarieCourant.salarie.NumSecu.toUpperCase().replace(/ /gi, "").replace(/\t/gi, "");
    	}

    	if (errorMessage.length > 0) {
    		for (let i = 0; i < errorMessage.length; i++) {
    			NotificationServiceInstance.SendFailed(errorMessage[i]);
    		}

    		return false;
    	}

    	this.salarieCourant.salarie.DateNaissance = moment.utc(this.dateNaissance).toDate();
    	this.salarieCourant.salarie.DateSortie = moment.utc(this.dateSortie).toDate();
    	this.salarieCourant.salarie.DateEntree = moment.utc(this.dateEntree).toDate();
    	this.salarieCourant.salarie.Photo = this.srcImage;
    	this.salarieCourant.salarie.CodeSociete = ParametresInstance.societeCourante.Code;

    	this.dataReady = false;

    	ServicesFactoryInstance.SalarieService.updateSalarieLight(this.salarieCourant.salarie, data => {
    		if (this.salarieCourant == undefined) {
				return;
			}
    		this.setData(data);
    		this.dataReady = true;
    		this.$emit("isModified", false);
    		this.isModified = false;
    		this.$emit("identiteUpdated", this.salarieCourant.salarie.Id);
    		NotificationServiceInstance.SendSuccess("L'enregistrement du salarié s'est correctement déroulé !");
    	}, () => {
    		this.dataReady = true;
    	});

    	return false;
	}

	public annuler(): void {
    	if (this.salarieCharges[this.currentId] != undefined) {
			this.salarieCharges[this.currentId].isModified = false;
		}
    	this.fetchData();
    	this.isModified = false;
    	this.$emit("isModified", false);

    	if (this.currentId == 0) {
			EventBus.$emit(EventConstants.CLOSE_TAB, { path: this.$router.currentRoute.path });
		}
	}

	public modifyDateEntree(): void {
    	if (this.salarieCourant && this.salarieCourant.salarie && ParametresInstance.societeCourante && ParametresInstance.societeCourante.PeriodeActive) {
    		this.salarieCourant.salarie.DateEntree = moment.utc(this.dateEntree).toDate();
    		let nombreJoursOuvree = 0;
    		const nombreParAn = ParametresInstance.societeCourante.JourneesAcquis ? ParametresInstance.societeCourante.JourneesAcquis : 25;
    		const moisCourant = ParametresInstance.societeCourante.PeriodeActive.getUTCMonth();
    		let nombreMois = moisCourant > 4 ? moisCourant - 5 : moisCourant + 7;
    		const dateDerniereRAZCompteurs = new Date(ParametresInstance.societeCourante.PeriodeActive.getUTCMonth() > 4 ? ParametresInstance.societeCourante.PeriodeActive.getUTCFullYear() : ParametresInstance.societeCourante.PeriodeActive.getUTCFullYear() - 1, 5, 1);
    		const dateDerniereRAZCompteursAnterieur = new Date(ParametresInstance.societeCourante.PeriodeActive.getUTCMonth() > 4 ? ParametresInstance.societeCourante.PeriodeActive.getUTCFullYear() - 1 : ParametresInstance.societeCourante.PeriodeActive.getUTCFullYear() - 2, 5, 1);

    		const dayInMonthDateEntree = new Date(this.salarieCourant.salarie.DateEntree.getUTCFullYear(), this.salarieCourant.salarie.DateEntree.getUTCMonth() + 1, 0).getDate();
    		if (this.salarieCourant.salarie.DateEntree && moment.utc(this.salarieCourant.salarie.DateEntree).isSameOrAfter(ParametresInstance.societeCourante.PeriodeActive)) {
    			nombreMois = 0;
    			this.salarieCourant.salarie.NombreCongesAcquis = 0;
    		} else if (this.salarieCourant.salarie.DateEntree && moment.utc(this.salarieCourant.salarie.DateEntree).isSameOrAfter(dateDerniereRAZCompteurs)) {
    			nombreMois = nombreMois - (this.salarieCourant.salarie.DateEntree.getUTCMonth() >= 5 ? (this.salarieCourant.salarie.DateEntree.getUTCMonth() - 5) : (this.salarieCourant.salarie.DateEntree.getUTCMonth() + 7));
    			nombreMois = nombreMois - ((this.salarieCourant.salarie.DateEntree.getDate() - 1) / dayInMonthDateEntree);
    			this.salarieCourant.salarie.NombreCongesAcquis = 0;
    		} else if (this.salarieCourant.salarie.DateEntree &&
                moment.utc(this.salarieCourant.salarie.DateEntree).isSameOrAfter(dateDerniereRAZCompteursAnterieur)) {
    			const nombreMoisAnterieur = 12 - (this.salarieCourant.salarie.DateEntree.getUTCMonth() >= 5 ? (this.salarieCourant.salarie.DateEntree.getUTCMonth() - 5) : (this.salarieCourant.salarie.DateEntree.getUTCMonth() + 7));
    			let nombreJoursOuvreeAnterieur = nombreParAn / 12 * nombreMoisAnterieur;
    			const finesseAuJour = nombreParAn / 12 / dayInMonthDateEntree * (this.salarieCourant.salarie.DateEntree.getDate() - 1);
    			nombreJoursOuvreeAnterieur = nombreJoursOuvreeAnterieur - finesseAuJour;
    			this.salarieCourant.salarie.NombreCongesAcquis = Math.round(nombreJoursOuvreeAnterieur * 100) / 100;
    		} else {
				this.salarieCourant.salarie.NombreCongesAcquis = nombreParAn;
			}

    		nombreJoursOuvree = nombreParAn / 12 * nombreMois;
    		this.salarieCourant.salarie.NombreCongesOuvert = Math.round(nombreJoursOuvree * 100) / 100;
		}

    	this.modify();
	}

	public modify(): void {
		this.isModified = true;
    	this.$emit("isModified", true);
	}

	public changeImage(event: any): void {
    	const someData = event.target.files[0];
    	const reader = new FileReader();
    	const _this = this;
    	reader.onload = function() {
    		const src = reader.result;
    		_this.updateSrc(src);
    	};

    	if (someData) {
    		reader.readAsDataURL(someData);
    	}
    	this.modify();
	}

	public updateSrc(data: any): void {
    	this.srcImage = data;
	}
}




// WEBPACK FOOTER //
// ./src/components/ficheSalarie/salarieLight/salarieLight.ts